
const contactForm = {
  'contactMe.header': 'Non posso aspettare, contattami!',
  'contactMe.instructions': 'Per favore completa il modulo sottostante così i nostri rappresentanti possono mettersi in contatto con te.',
  'contactMe.name': 'Nome',
  'contactMe.lastName': 'Cognome',
  'contactMe.email': 'Email (opzionale)',
  'contactMe.country': 'Paese',
  'contactMe.whatsappNumber': 'Numero WhatsApp',
  'contactMe.countryCode': 'Codice paese',
  'contactMe.language': 'Lingua Preferita',
  'contactMe.message': 'Messaggio (opzionale)',
  'contactMe.submit': 'Invia',
  'contactMe.submitting': 'Invio in corso...',
  'contactMe.success.title': 'Grazie per averci contattato!',
  'contactMe.success.message': 'Le tue informazioni sono state inviate con successo. Un rappresentante di The Club ti contatterà presto.',
  'contactMe.placeholders.name': 'Inserisci il tuo nome',
  'contactMe.placeholders.lastName': 'Inserisci il tuo cognome',
  'contactMe.placeholders.email': 'Inserisci la tua email',
  'contactMe.placeholders.country': 'Seleziona il tuo paese',
  'contactMe.placeholders.countryCode': 'Codice',
  'contactMe.placeholders.whatsappNumber': 'Numero WhatsApp',
  'contactMe.placeholders.language': 'Indica la tua lingua preferita',
  'contactMe.placeholders.message': 'Scrivi il tuo messaggio qui',
  'contactMe.errors.name': 'Il nome è richiesto',
  'contactMe.errors.lastName': 'Il cognome è richiesto',
  'contactMe.errors.email': 'Indirizzo email non valido',
  'contactMe.errors.country': 'Il paese è richiesto',
  'contactMe.errors.countryCode': 'Il codice paese è richiesto',
  'contactMe.errors.whatsappNumber': 'Il numero WhatsApp è richiesto',
  'contactMe.errors.language': 'La lingua è richiesta',
  'contactMe.errors.messageMaxLength': 'Il messaggio non può superare {max} caratteri',
  'contactMe.errors.submission': 'Invio del modulo fallito',
  'contactMe.errors.generic': 'Qualcosa è andato storto. Riprova per favore.',
  'contactMe.page.title': 'Inizia a Guadagnare Prima di Tutti',
};

export default contactForm;
